export default __webpack_public_path__ + "static/media/handing_coin.70288935.jpg";